module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"albums":"{appTitle} - Albums","album":"{appTitle} - Album","newalbum":"{appTitle} - New album","user":"{appTitle} - User","termsconditions":"{appTitle} - Terms and Conditions"},"fr":{"albums":"{appTitle} - Albums","album":"{appTitle} - Album","newalbum":"{appTitle} - Nouvel album","user":"{appTitle} - Utilisateur","termsconditions":"{appTitle} - Termes et conditions"}}')
  delete Component.options._Ctor
}
